module.exports = __webpack_public_path__ + "img/ic_twitter.a16cf263.svg";